/*
 * @Autor: 陈钊贤
 * @Version: 1.0
 * @Date: 2020-05-21 13:59:26
 * @LastEditors: 陈钊贤
 * @Description:
 * @LastEditTime: 2021-07-26 10:17:48
 */
import Vue from "vue";
import configData from "../config/config";
import store from "../store/index";
import router from "../router/index";
import i18n from "@/config/i18n";
const common = {
    /**
     * 存本地数据
     * @param item 名字
     * @param str 数据
     * @param type 本地数据类型,没有  sessionStorage 有 localStorage
     */
    save(item, str, type) {
        const typeData = type || 0;
        if (typeof str == "object") {
            str = JSON.stringify(str);
        }
        const win = window;
        if (typeData) {
            win.localStorage.removeItem(item);
            win.localStorage[item] = str;
        }
        else {
            win.sessionStorage.removeItem(item);
            win.sessionStorage[item] = str;
        }
    },
    /**
     * 取本地数据
     * @param item 名字
     * @param type 本地数据类型,没有  sessionStorage 有  localStorage
     */
    get(item, type) {
        let value;
        const typeData = type || 0;
        const win = window;
        if (typeData) {
            if (win.localStorage[item] !== undefined) {
                value = win.localStorage[item];
                if (value.indexOf("{") == 0 || value.indexOf("[") == 0) {
                    return JSON.parse(value);
                }
                else {
                    return value;
                }
            }
            else {
                return false;
            }
        }
        else {
            if (win.sessionStorage[item] !== undefined) {
                value = win.sessionStorage[item];
                if (value.indexOf("{") == 0 || value.indexOf("[") == 0) {
                    return JSON.parse(value);
                }
                else {
                    return value;
                }
            }
            else {
                return false;
            }
        }
    },
    /**
     * 删除本地数据
     * @param name 名字
     * @param type 本地数据类型,没有 sessionStorage  有  localStorage
     */
    remove(name, type) {
        const typeData = type || 0;
        const item = name || "-1";
        const win = window;
        if (typeData) {
            if (item == "-1") {
                win.localStorage.clear();
            }
            else {
                win.localStorage.removeItem(item);
            }
        }
        else {
            if (item == "-1") {
                win.sessionStorage.clear();
            }
            else {
                win.sessionStorage.removeItem(item);
            }
        }
    },
    out() {
        this.remove();
        const win = window;
        const state = store.state; // eslint-disable-line
        const userInfo = state.sys.userInfo;
        if (configData.loginUrl) {
            win.location.href = configData.loginUrl + "?oprPkId=" + userInfo.oprPkId;
        }
        else {
            // router.push("/login");
            // win.location.href =
            //   win.location.origin +
            //   configData.host +
            //   "/#/login?oprPkId=" +
            //   userInfo.oprPkId;
            win.history.go(0);
        }
    },
    parseParam(json) {
        const params = Object.keys(json)
            .map(function (key) {
            return encodeURIComponent(key) + "=" + encodeURIComponent(json[key]);
        })
            .join("&");
        return params;
    },
    timeStrto(strTime) {
        let newStr = strTime.replace(/:/g, "-");
        newStr = newStr.replace(/ /g, "-");
        const arr = newStr.split("-");
        const datum = new Date(Date.UTC(parseInt(arr[0]), parseInt(arr[1]) - 1, parseInt(arr[2]), parseInt(arr[3]) - 8, parseInt(arr[4]), parseInt(arr[5])));
        const time = datum.getTime() / 1000;
        return time;
    },
    /**
     * 获取当月有几天
     * @param year
     * @param month
     * @returns
     */
    getMonthDay(year, month) {
        const days = new Date(year, month, 0).getDate();
        return days;
    },
    /**
     * 获取当前时间
     * @param type  时间格式
     * @param dateObj date
     * @returns
     */
    thisTimes: function (type, dateObj) {
        const d = dateObj || new Date();
        let y = d.getFullYear();
        let m = d.getMonth() + 1;
        let dd = d.getDate();
        const day = d.getDay(); // 星期几
        let h = d.getHours(); // 时
        let f = d.getMinutes(); // 分
        let s = d.getSeconds(); // 秒
        y = y < 10 ? "0" + y : y;
        m = m < 10 ? "0" + m : m;
        h = h < 10 ? "0" + h : h;
        dd = dd < 10 ? "0" + dd : dd;
        f = f < 10 ? "0" + f : f;
        s = s < 10 ? "0" + s : s;
        let json = "";
        let yy = "";
        const dayObj = {
            "0": i18n.t("timeObj.0"),
            "1": i18n.t("timeObj.1"),
            "2": i18n.t("timeObj.2"),
            "3": i18n.t("timeObj.3"),
            "4": i18n.t("timeObj.4"),
            "5": i18n.t("timeObj.5"),
            "6": i18n.t("timeObj.6"),
        };
        let text = "";
        switch (type) {
            case "yy":
                json = y;
                break;
            case "mm":
                json = m;
                break;
            case "dd":
                json = dd;
                break;
            case "hh":
                json = h;
                break;
            case "ff":
                json = f;
                break;
            case "ss":
                json = s;
                break;
            case "day":
                json = day;
                break;
            case "days":
                json = new Date(d.getFullYear(), d.getMonth() + 1, 0).getDate();
                break;
            case "yyyy":
                json = y;
                break;
            case "yyyy-MM":
                json = y + "-" + m;
                break;
            case "yyyy-MM-s":
                yy = y + "";
                yy = yy.substring(yy.length - 3, yy.length - 1);
                json = yy + "-" + m;
                break;
            case "yyyy-MM-dd":
                json = y + "-" + m + "-" + dd;
                break;
            case "yyyy-MM-dd HH:MM":
                json = y + "-" + m + "-" + dd + " " + h + ":" + f;
                break;
            case "yyyy-MM-dd HH:MM:SS":
                json = y + "-" + m + "-" + dd + " " + h + ":" + f + ":" + s;
                break;
            case "HH:MM":
                json = h + ":" + f;
                break;
            case "HH:MM:SS":
                json = h + ":" + f + ":" + s;
                break;
            case "allTime":
                if (h < 9) {
                    text = i18n.t("timeObj.earlyMorning") + "";
                }
                else if (h < 12) {
                    text = i18n.t("timeObj.morning") + "";
                }
                else if (h < 14) {
                    text = i18n.t("timeObj.noon") + "";
                }
                else if (h < 17) {
                    text = i18n.t("timeObj.afternoon") + "";
                }
                else if (h < 19) {
                    text = i18n.t("timeObj.night") + "";
                }
                json =
                    y +
                        "-" +
                        m +
                        "-" +
                        dd +
                        " " +
                        dayObj[day] +
                        " " +
                        text +
                        " " +
                        h +
                        ":" +
                        f +
                        ":" +
                        s;
                break;
            default:
                json = y + "-" + m + "-" + dd + " " + h + ":" + f + ":" + s;
                break;
        }
        return json;
    },
    userDate: function (uData, type) {
        const myDate = new Date(uData);
        const year = this.t(myDate.getFullYear());
        const month = this.t(myDate.getMonth() + 1);
        const day = this.t(myDate.getDate());
        const hours = this.t(myDate.getHours());
        const minutes = this.t(myDate.getMinutes());
        const second = this.t(myDate.getSeconds());
        if (type === "yyyy") {
            return year;
        }
        else if (type === "yyyy-MM") {
            return year + "-" + month;
        }
        else if (type === "yyyy-MM-dd") {
            return year + "-" + month + "-" + day;
        }
        else if (type === "HH:MM") {
            return hours + ":" + minutes;
        }
        else if (type === "HH:MM:SS") {
            return hours + ":" + minutes + ":" + second;
        }
        else {
            return (year +
                "-" +
                month +
                "-" +
                day +
                " " +
                hours +
                ":" +
                minutes +
                ":" +
                second);
        }
    },
    /**
     * 获取上一个月的今天
     * @param date  xxxx-xx-xx
     * @returns xxxx-xx-xx
     */
    getPreMonth(date) {
        const arr = date.split("-");
        const year = parseInt(arr[0]); //获取当前日期的年份
        const month = parseInt(arr[1]); //获取当前日期的月份
        const day = parseInt(arr[2]); //获取当前日期的日
        // const days = new Date(year, month, 0).getDate(); //获取当前日期中月的天数
        let year2 = year;
        let month2 = month - 1;
        if (month2 == 0) {
            year2 = year2 - 1;
            month2 = 12;
        }
        let day2 = day;
        // const days2 = new Date(year2, month2, 0);
        const days2 = new Date(year2, month2, 0).getDate();
        if (day2 > days2) {
            day2 = days2;
        }
        let m = month2 + "";
        if (month2 < 10) {
            m = "0" + month2;
            // month2 = "0" + month2;
        }
        let d = day2 + "";
        if (day2 < 10) {
            d = "0" + day2;
        }
        const t2 = year2 + "-" + m + "-" + d;
        return t2;
    },
    /**
     * 获取当前 n 个月
     * @param n
     * @param dateObj  new Date()
     * @returns
     */
    beforeTime(n, dateObj) {
        const date = dateObj || new Date();
        date.setMonth(date.getMonth() - n);
        date.toLocaleDateString();
        const y = date.getFullYear();
        const m = date.getMonth() + 1;
        return y + "-" + this.t(m);
    },
    /**
     * 获取  N 天后的日期
     * @param AddDayCount  负就是 N天前，正就是 N天后
     * @returns
     */
    getDateStr(AddDayCount, dateObj) {
        const dd = dateObj || new Date();
        dd.setDate(dd.getDate() + AddDayCount); //获取AddDayCount天后的日期
        const y = dd.getFullYear();
        const m = dd.getMonth() + 1; //获取当前月份的日期
        const d = dd.getDate();
        return y + "-" + this.t(m) + "-" + this.t(d);
    },
    getDateWeek(date) {
        const arr = date.split("-");
        const year = parseInt(arr[0]); //获取当前日期的年份
        const month = parseInt(arr[1]); //获取当前日期的月份
        const day = parseInt(arr[2]); //获取当前日期的日
        const tmpdate = new Date(year, month - 1, day);
        const whichWeek = tmpdate.getDay();
        return whichWeek;
    },
    t(time) {
        if (time < 10) {
            return "0" + time;
        }
        else {
            return time;
        }
    },
    tableNoData(text) {
        const tableText = text || "暂无数据";
        return ("<div class='table-no-data'><i class='ivu-icon ivu-icon-ios-folder-open-outline'></i><p>" +
            tableText +
            "</p></div>");
    },
    imgShowUrl(str) {
        if (str) {
            const pos = str.indexOf(configData.fileImg);
            let url = str.substring(pos, str.length);
            url = url.replace(configData.fileImg, "");
            return url;
        }
        else {
            return "";
        }
    },
    fileUrl(value) {
        if (value && value.indexOf("http") == 0) {
            return value;
        }
        else if (value && typeof value !== "undefined") {
            return configData.fileImg + value;
        }
        return "";
    },
    debounce(func, timeout) {
        let timer;
        return (...args) => {
            clearTimeout(timer);
            timer = setTimeout(() => {
                func(...args);
            }, timeout);
        };
    },
    request(paras) {
        const win = window;
        const url = decodeURIComponent(win.location.href);
        const paraString = url
            .substring(url.indexOf("?") + 1, url.length)
            .split("&");
        const paraObj = {};
        /* eslint-disable */
        var j;
        for (var i = 0; (j = paraString[i]); i++) {
            paraObj[j.substring(0, j.indexOf('=')).toLowerCase()] = j.substring(j.indexOf('=') + 1, j.length);
        }
        /* eslint-enable */
        const returnValue = paraObj[paras.toLowerCase()];
        if (typeof returnValue === "undefined") {
            return "";
        }
        else {
            return returnValue;
        }
    },
    goBack(route, goBackUrl) {
        const win = window;
        store.commit("urlRemoveRouter", route.path);
        if (goBackUrl) {
            let goUrl = "";
            const state = store.state; // eslint-disable-line
            const goRouterList = state.sys.goRouterList;
            const goRouter = state.sys.goRouter;
            if (goRouterList.length > 1) {
                const upper = goRouterList[goRouterList.length - 2].url;
                if (upper == goBackUrl) {
                    // 如果是正常父子页面进入返回的流程（经过历史的倒数第二个 == 传入的url），返回空，执行浏览器的返回事件
                    goUrl = "";
                }
                else {
                    // 如果不是正常浏览，就对比找出已经缓存的url组件的路径，因为上一页有可能带参数,如果已经被干掉，就返回传入的 url
                    goRouter.map((item) => {
                        if (item.url == goBackUrl) {
                            goUrl = item.fullPath;
                        }
                    });
                }
            }
            if (goUrl == "") {
                win.history.go(-1);
            }
            else {
                router.push(goUrl);
            }
        }
        else {
            win.history.go(-1);
        }
        this.remove(route.path);
    },
    /**
     * 对象中去掉空的字段，一般请求接口的参数处理用到
     * @param data
     * @returns
     */
    forNull(data) {
        const json = {};
        for (const i in data) {
            if (data[i] !== "" && data[i] !== undefined) {
                json[i] = data[i];
            }
        }
        return json;
    },
    /**
     * 把列表中的 null 转成 - ，一般表格用到
     * @param tableList 列表
     * @param notHandled  处理的字段
     * @returns
     */
    forTableList(tableList, notHandled) {
        if (tableList) {
            const list = [];
            tableList.map((item) => {
                const itemData = {};
                for (const i in item) {
                    // notHandled 不处理的字段
                    itemData[i] =
                        item[i] ||
                            item[i] == 0 ||
                            (notHandled && notHandled.indexOf(i) != -1)
                            ? item[i]
                            : "-";
                }
                list.push(itemData);
            });
            return list;
        }
        else {
            return [];
        }
    },
    startEndTime(start, end) {
        if (start != "" && end != "") {
            if (start.split(" ").length == 1) {
                start = start + " 00:00:00";
            }
            if (end.split(" ").length == 1) {
                end = end + " 23:59:59";
            }
            const startTime = this.timeStrto(start);
            const endTime = this.timeStrto(end);
            if (endTime > startTime) {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return true;
        }
    },
    toFixed(number, n) {
        if (typeof number == "string" && isNaN(parseFloat(number))) {
            return 0;
        }
        const m = n ? n : 2;
        const resultNum = Math.round(Math.pow(10, m) * number) / Math.pow(10, m);
        return resultNum;
    },
    addZero(num) {
        return num > 9 ? num : "0" + num;
    },
    formatDelayTime(time) {
        if (!time && typeof time !== "number") {
            return "-";
        }
        if (typeof time == "string") {
            time = parseFloat(time);
        }
        return `${this.addZero((time / 100).toFixed(0))}:${this.addZero(time % 100)}`;
    },
    compare(property) {
        return function (a, b) {
            const value1 = a[property];
            const value2 = b[property];
            return value1 - value2;
        };
    },
    sortNumber(arr, type) {
        return arr.sort(function (a, b) {
            if (type) {
                return a - b; // —>升序排列
            }
            else {
                return b - a; //降序排列，
            }
        });
    },
    sortList(arr, str) {
        // 数组排序
        if (Object.prototype.toString.call(arr).slice(8, -1) === "Array") {
            const returnArr = arr.sort(this.compare(str));
            return returnArr;
        }
        else {
            return arr;
        }
    },
    copyText(text) {
        const win = window;
        if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
            //区分iPhone设备
            const data = {};
            data.span = document.createElement("span");
            data.span.innerHTML = text;
            //span.style.display='none';
            data.span.id = "copyTextSpan";
            document.body.appendChild(data.span);
            win.getSelection().removeAllRanges(); //这段代码必须放在前面否则无效
            const range = document.createRange();
            // 选中需要复制的节点
            range.selectNode(data.span);
            // 执行选中元素
            win.getSelection().addRange(range);
            // 执行 copy 操作
            document.execCommand("copy");
            // 移除选中的元素
            win.getSelection().removeAllRanges();
            data.span["parentNode"].removeChild(data.span);
            Vue.prototype.$Message.success("复制成功");
        }
        else {
            const data = {};
            data.oInput = document.createElement("textarea");
            data.oInput.value = text;
            document.body.appendChild(data.oInput);
            data.oInput.select(); // 选择对象
            document.execCommand("Copy"); // 执行浏览器复制命令
            data.oInput.className = "oInput";
            data.oInput.style.display = "none";
            data.oInput.parentNode.removeChild(data.oInput);
            Vue.prototype.$Message.success("复制成功");
        }
    },
    resetForm(form) {
        for (const i in form) {
            if (i != "oprPkId" && i != "globalPageSize") {
                if (typeof form[i] == "string" || typeof form[i] == "number") {
                    form[i] = "";
                }
                else if (Array.isArray(form[i])) {
                    form[i] = [];
                }
                else if (typeof form[i] == "object") {
                    form[i] = {};
                }
            }
        }
        form.globalPageIndex = 1;
        return form;
    },
    isJSON(str) {
        if (typeof str === "string") {
            try {
                const obj = JSON.parse(str);
                if (typeof obj === "object" && obj) {
                    return true;
                }
                else {
                    return false;
                }
            }
            catch (e) {
                return false;
            }
        }
        else {
            return false;
        }
    },
    getData(day) {
        const today = new Date();
        const targetday = today.getTime() + 1000 * 60 * 60 * 24 * day;
        today.setTime(targetday);
        const tYear = today.getFullYear();
        let tMonth = today.getMonth();
        let tDate = today.getDate();
        tMonth = this.doHandMonth(tMonth + 1);
        tDate = this.doHandMonth(tDate);
        return tYear + "-" + tMonth + "-" + tDate;
    },
    doHandMonth(month) {
        let m = month + "";
        if (month.toString().length == 1) {
            m = "0" + month;
        }
        return m;
    },
    /**
     * 把例如1230转为12:30
     * @param data 08：00
     * @param processData
     */
    convertStringToTimes(data) {
        const hour = String(Math.floor(Number(data) / 100)).padStart(2, "0");
        const min = String(Number(data) % 100).padStart(2, "0");
        const time = hour + ":" + min;
        return time;
    },
    /**
     * 把例如12:30转换为1230
     * @param data 小时*100+分钟
     */
    convertTimesToString(data) {
        const times = data.split(":");
        const str = Number(times[0]) * 100 + Number(times[1]);
        return str;
    },
    /**
     * 获取路由中的权限
     */
    getPrivilegeVoObj(route) {
        return route.meta && route.meta.privilegeVoObj
            ? route.meta.privilegeVoObj
            : {};
    },
    /**
     *
     * @param array 判断数组是否重复
     * @returns
     */
    hasDuplicateStrings(array) {
        const set = new Set(array);
        return set.size !== array.length;
    },
    /**
     *
     * @param numBer 费率保留小数
     * @returns
     */
    retaToFixed(value) {
        const multiplied = Number((value * 100).toFixed(2));
        const result = Math.ceil(multiplied) / 100;
        return result;
    },
    /**
     * 深层合并对象
     * @param obj1
     * @param obj2
     * @returns
     */
    deepMerge(obj1, obj2) {
        // 遍历obj2的属性
        for (const key in obj2) {
            // 如果obj2的属性是一个对象，且obj1也有相同的属性，则递归合并这两个对象
            if (typeof obj2[key] === "object" &&
                Object.prototype.hasOwnProperty.call(obj1, key) &&
                typeof obj1[key] === "object") {
                obj1[key] = this.deepMerge(obj1[key], obj2[key]);
            }
            else {
                // 否则，直接将obj2的属性赋值给obj1
                obj1[key] = obj2[key];
            }
        }
        return obj1;
    },
    /**
     * 获取百分比
     * @param value
     * @returns
     */
    getProgress(value, total, fixed) {
        fixed = fixed || 2;
        return total > 0
            ? parseFloat(((value / total) * 100).toFixed(fixed)) + "%"
            : "0%";
    },
};
export default common;
